/* ---------------------------------------------------------------------------
 * MD Fashionwear — rebuild the recommendation carousel after a drawer re-render
 *
 * THE BUG THIS FIXES, MEASURED
 * Adding an item made the block vanish. The theme replaces the entire cart
 * drawer markup roughly 2.8 SECONDS after the add — long after any cart event
 * has fired. The replacement comes straight from Liquid, so #md-recs returns
 * empty, hidden, with no data-ready, and every timer-based refill had already
 * run and given up.
 *
 * So this does not rely on timing. A MutationObserver watches for a fresh,
 * unclaimed #md-recs and refills it the moment it appears, from the set saved in
 * sessionStorage — no network, no flicker, same products.
 *
 * It also puts the shopper back where they were: the carousel scroll, the drawer
 * scroll and the page scroll are all restored, so adding an item no longer
 * throws them back to the top.
 *
 * The observer cannot loop: it only acts when #md-recs has no data-ready, and
 * buildFrom sets that as soon as it succeeds.
 *
 * Loaded AFTER md-cart-recs.js, which provides buildFrom.
 * ------------------------------------------------------------------------- */

(function () {
  'use strict';

  function needsWork() {
    var host = document.getElementById('md-recs');
    if (!host) return null;
    if (host.getAttribute('data-ready') === '1') return null;
    return host;
  }

  function hydrate() {
    var host = needsWork();
    if (!host) return false;

    var store = window.MDCartStore;
    var recs = window.MDCartRecs;
    if (!store || !recs || !recs.buildFrom) return false;

    var saved = store.load();
    if (!saved || !saved.shown || !saved.shown.length) return false;

    var ok = recs.buildFrom(saved.shown, saved.reserve, saved.excluded);
    if (ok && store.restoreScroll) store.restoreScroll();
    return ok;
  }

  var queued = false;

  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      hydrate();
    }, 30);
  }

  function boot() {
    hydrate();

    // The important part: fires whenever the theme swaps the drawer markup in,
    // whenever that happens to be.
    if (window.MutationObserver && document.body) {
      new MutationObserver(function () {
        if (needsWork()) queue();
      }).observe(document.body, { childList: true, subtree: true });
    }

    // Belt and braces, staggered because the re-render can land seconds later.
    var stagger = function () {
      [0, 200, 600, 1200, 2000, 3000, 4000].forEach(function (ms) {
        setTimeout(hydrate, ms);
      });
    };

    document.documentElement.addEventListener('cart:refresh', stagger);
    document.documentElement.addEventListener('cart:change', stagger);
    document.addEventListener('cart:change', stagger);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.MDCartHydrate = { run: hydrate };
})();
